import React, { useState } from "react";
import { EmailLogo, LockIcon } from "../../assets/svg";
import FormBox from "./formBox";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

function ForgotPasswordPage() {
  const [formData, setFormData] = useState({
    email: "",
  });
  const [passwordData, setPasswordData] = useState({
    email: formData.email,
    password: "",
    confirmationCode: "",
  });
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpScreen, setOtpScreen] = useState(false);
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const validateForm = () => {
    let formErrors = {};

    if (!passwordData.confirmationCode)
      formErrors.confirmationCode = "Otp code is required";
    if (!passwordData.password) {
      formErrors.newPassword = "Password is required";
    } else if (passwordData.password.length < 8) {
      formErrors.newPassword = "Password must be at least 8 characters long";
    } else if (!/(?=.*[A-Za-z])(?=.*\d)/.test(passwordData.password)) {
      formErrors.newPassword = "Password must contain both letters and numbers";
    }
    if (passwordData.password !== newPassword)
      formErrors.newPassword = "Password does not match";

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleLoginClick = () => {
    navigate("/login");
  };

  const handleCancelChangePassword = () => {
    setPasswordData({
      email: formData.email,
      password: "",
      confirmationCode: "",
    });
    setNewPassword("");
    setOtpScreen(false);
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email) return;
    setErrors({});
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/sendMail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.status === 201 || data.status === 200) {
          console.log("mail sent succesfully");
          toast.success(data.message, {
            style: {
              border: "1px solid #021F7E",
              padding: "16px",
              color: "#0573E3",
            },
            iconTheme: {
              primary: "#021F7E",
              secondary: "#fff",
            },
            duration: 6000,
          });
          setPasswordData((prevFormData) => ({
            ...prevFormData,
            email: formData.email,
          }));
          setOtpScreen(true);
        } else {
          console.log(data);
        }
      } else {
        const data = await response.json();
        toast.error(data.error, {
          style: {
            border: "1px solid #FE0000",
            padding: "16px",
            color: "#FE0000",
          },
          iconTheme: {
            primary: "#FE0000",
            secondary: "#FE000099",
          },
          duration: 6000,
        });
        setErrors({ email: data.error });
        console.error("Failed to send mail", data.error);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    setErrors({});
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/forgotPassword`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(passwordData),
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.status === 201 || data.status === 200) {
          toast.success("Password Changed Successfuly", {
            style: {
              border: "1px solid #021F7E",
              padding: "16px",
              color: "#0573E3",
            },
            iconTheme: {
              primary: "#021F7E",
              secondary: "#fff",
            },
            duration: 6000,
          });
          handleLoginClick();
        } else {
          console.error("Error:", data);
        }
      } else {
        const data = await response.json();
        setErrors({ confirmationCode: data.message });
        toast.error(data.message, {
          style: {
            border: "1px solid #FE0000",
            padding: "16px",
            color: "#FE0000",
          },
          iconTheme: {
            primary: "#FE0000",
            secondary: "#FE000099",
          },
          duration: 6000,
        });
        console.error("Failed to change password: ", data);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <FormBox>
        {!otpScreen ? (
          <>
            <h2 className="colorHeading">Code Insect!</h2>
            <h4>Forgot Password</h4>
            <div className="customLogin">
              <EmailLogo />
              <input
                name="email"
                type="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={(e) =>
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    email: e.target.value,
                  }))
                }
              />
            </div>
            {errors.email && <span className="errorClass">{errors.email}</span>}
            {loading ? (
              <button className="colorBtn submitBtn">Sending...</button>
            ) : (
              <button className="colorBtn submitBtn" onClick={handleSubmit}>
                Submit
              </button>
            )}
            <button className="whiteBtn loginBtn" onClick={handleLoginClick}>
              <span>Login</span>
            </button>
          </>
        ) : (
          <>
            <h2 className="colorHeading">Change Password!</h2>
            <h4>We have sent 6 digit code on your email</h4>
            <div className="customLogin">
              <input
                type="text"
                placeholder="Enter 6-digit code"
                maxLength="6"
                value={passwordData.confirmationCode}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value))
                    setPasswordData((prevFormData) => ({
                      ...prevFormData,
                      confirmationCode: e.target.value,
                    }));
                }}
              />
            </div>
            {errors.confirmationCode && (
              <span className="errorClass">{errors.confirmationCode}</span>
            )}
            <div className="customLogin" style={{ marginTop: "10px" }}>
              <LockIcon />
              <input
                type="password"
                placeholder="Enter New Password"
                value={passwordData.password}
                onChange={(e) =>
                  setPasswordData((prevFormData) => ({
                    ...prevFormData,
                    password: e.target.value,
                  }))
                }
              />
            </div>
            {errors.password && (
              <span className="errorClass">{errors.password}</span>
            )}
            <div className="customLogin" style={{ marginTop: "10px" }}>
              <LockIcon />
              <input
                type="password"
                placeholder="Re-Enter New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
            {errors.newPassword && (
              <span className="errorClass">{errors.newPassword}</span>
            )}
            {loading ? (
              <button className="colorBtn submitBtn">Sending...</button>
            ) : (
              <button
                className="colorBtn submitBtn"
                onClick={handleChangePassword}
              >
                Submit
              </button>
            )}
            <button
              className="whiteBtn loginBtn"
              onClick={handleCancelChangePassword}
            >
              <span>Back</span>
            </button>
          </>
        )}
      </FormBox>
    </>
  );
}

export default ForgotPasswordPage;
